export enum LabCollectionTechniqueEnum {
  Venipuncture = 1,
  Capillary = 2
}

export const LabCollectionTechniqueOptions = [
{ id: 1, label: 'Venipuncture' },
{ id: 2, label: 'Capillary (Point-of-Care)' }
];
